export default __webpack_public_path__ + "static/media/accounting.afc50611.png";